import * as React from 'react'
import { Helmet } from 'react-helmet'

const StructuredData = () => {
  // Main Business Schema
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Bisma Rénovation",
    "image": "https://www.bisma.fr/images/logo-bisma-renovation.jpg",
    "@id": "https://www.bisma.fr",
    "url": "https://www.bisma.fr",
    "telephone": "+33983519498",
    "priceRange": "€€€",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Île-de-France",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "48.8566",
      "longitude": "2.3522"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/",
      "https://www.instagram.com/",
      "https://www.linkedin.com/",
      "https://twitter.com/"
    ],
    "areaServed": [
      {
        "@type": "State",
        "name": "Île-de-France"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Seine-et-Marne (77)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Yvelines (78)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Essonne (91)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Hauts-de-Seine (92)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Seine-Saint-Denis (93)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Val-de-Marne (94)"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Val-d'Oise (95)"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de rénovation énergétique",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Isolation thermique par l'extérieur",
            "description": "Installation d'isolation thermique par l'extérieur pour améliorer la performance énergétique",
            "provider": {
              "@type": "Organization",
              "name": "Bisma Rénovation"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pompe à chaleur air/eau",
            "description": "Installation de pompes à chaleur air/eau et air/air avec MaPrimeRénov'",
            "provider": {
              "@type": "Organization",
              "name": "Bisma Rénovation"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Isolation des combles",
            "description": "Isolation des combles perdus et aménagés par soufflage ou déroulage",
            "provider": {
              "@type": "Organization",
              "name": "Bisma Rénovation"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Rénovation énergétique globale",
            "description": "Rénovation d'ampleur complète avec aides MaPrimeRénov' et CEE",
            "provider": {
              "@type": "Organization",
              "name": "Bisma Rénovation"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Chaudière à granulés",
            "description": "Installation de chaudières à granulés et bois bûches écologiques",
            "provider": {
              "@type": "Organization",
              "name": "Bisma Rénovation"
            }
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "98"
    }
  }

  // Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Bisma Rénovation",
    "alternateName": "Bisma",
    "url": "https://www.bisma.fr",
    "logo": "https://www.bisma.fr/images/logo-bisma-renovation.jpg",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+33983519498",
      "contactType": "customer service",
      "areaServed": "FR",
      "availableLanguage": "French"
    },
    "sameAs": [
      "https://www.facebook.com/",
      "https://www.instagram.com/",
      "https://www.linkedin.com/"
    ]
  }

  // Breadcrumb List Schema (will be customized per page)
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://www.bisma.fr"
      }
    ]
  }

  return (
    <Helmet>
      {/* Business Schema */}
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>
      
      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      
      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  )
}

export default StructuredData
